import { Link } from '@tribeplatform/react-ui-kit/Link';
export const LinkBlock = Link;
//# sourceMappingURL=Block.js.map